<template>
    <section class="bg-login-image relative flex flex-col gap-3 min-h-screen">
        <!-- Overlay oscuro -->
        <div class="absolute inset-0 bg-black/50"></div>

        <!-- Contenido -->
        <div
            class="relative flex flex-col w-full max-w-lg items-center lg:max-w-md xl:max-w-xl gap-6 px-6 py-8 sm:px-12 md:px-16 m-auto bg-white/90 rounded-lg shadow-lg dark:bg-gray-800">
            <img src="../../../assets/logo.png" alt="Logo" class="w-28" />

            <div class="w-full">
                <h1 class="text-2xl font-bold text-gray-900 dark:text-white text-center mb-8">
                    Recupera tu contraseña
                </h1>
                <p class="mt-2 text-center text-sm text-gray-700 dark:text-gray-300">
                    Ingresa tu dirección de correo electrónico y te enviaremos las instrucciones para restablecer tu
                    contraseña.
                </p>
                
                <form class="space-y-6 mt-6" @submit.prevent="sendResetEmail">
                    <div>
                        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Correo Electrónico
                        </label>
                        <input type="email" v-model="email" name="email" id="email"
                            class="w-full p-3 text-sm border rounded-lg bg-gray-50 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="tucorreo@ejemplo.com" required />
                    </div>
                    <button type="submit" :disabled="isLoading"
                        class="w-full flex items-center justify-center px-4 py-3 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
                        <svg v-if="isLoading" class="w-5 h-5 animate-spin mr-3 text-white"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 101" fill="none">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#E5E7EB" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor" />
                        </svg>
                        <span v-if="isLoading">Enviando instrucciones...</span>
                        <span v-else>Enviar</span>
                    </button>
                    
                    <div v-if="errorMessage" class="text-center text-sm text-red-600">
                        {{ errorMessage }}
                    </div>
                    <div v-if="successMessage" class="text-center text-sm text-green-600">
                        {{ successMessage }}
                    </div>
                </form>
            </div>
        </div>

    </section>
</template>

<script>
import { getAuth, signOut, signInWithEmailAndPassword } from 'firebase/auth';
import { getFunctions, httpsCallable} from "firebase/functions"; // Importar funciones para invocar Cloud Functions
export default {
    name: "RecuperarCuenta",
    data() {
        return {
            email: '',
            isLoading: false,
            errorMessage: '',
            successMessage: ''
        };
    },
    methods: {
        async sendResetEmail() {
            // Reiniciamos mensajes previos
            this.errorMessage = '';
            this.successMessage = '';

            if (!this.email) {
                this.errorMessage = 'Por favor, ingresa tu correo electrónico.';
                return;
            }
            this.isLoading = true;
            try {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@$*';

                let nuevaContrasena = '';
                for (let i = 0; i < 8; i++) {
                    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                    nuevaContrasena += caracteres[indiceAleatorio];
                }
                const data = {
                    email: this.email,
                    nuevaContrasena: nuevaContrasena
                }
                const functions = getFunctions();
                const forgotPassword = httpsCallable(functions, 'forgotPassword');
                await forgotPassword(data);
                const auth = getAuth();
                await signOut(auth)
                const userCredential = await signInWithEmailAndPassword(auth, this.email, nuevaContrasena);
                userCredential;
                // Primero eliminamos al usuario de Firebase Auth
                this.$router.push({ path: './recuperar-completado' });
            } catch (error) {
                console.error('Error al enviar el correo de restablecimiento:', error);
                this.errorMessage = 'No se encontró usuario con ese correo.';
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>




<style scoped>
/* Puedes agregar estilos personalizados aquí si lo deseas */
.bg-login-image {
    background-image: url('/public/fondologin.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh;
}
</style>